import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookies carry the auth token; withCredentials sends them cross-origin.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Build an absolute media URL from a backend-relative path (e.g. /api/avatars/<id>).
export const mediaUrl = (p) => (p ? (p.startsWith("http") ? p : `${BACKEND_URL}${p}`) : null);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}
